const RECALCULATE_ORGANIZATION_METRICS = 'dofe-bo/METRICS/RECALCULATE_ORGANIZATION_METRICS'
const RECALCULATE_ORGANIZATION_METRICS_SUCCESS = 'dofe-bo/METRICS/RECALCULATE_ORGANIZATION_METRICS_SUCCESS'
const RECALCULATE_ORGANIZATION_METRICS_FAIL = 'dofe-bo/METRICS/RECALCULATE_ORGANIZATION_METRICS_FAIL'


const initialState = {
  data: [],
  isLoading: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case RECALCULATE_ORGANIZATION_METRICS:
      return {
        ...state,
        isLoading: true
      }
    case RECALCULATE_ORGANIZATION_METRICS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.result
      }
    case RECALCULATE_ORGANIZATION_METRICS_FAIL:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}

export const recalculateOrganizationMetrics = () => {

  const data = { organizationIdList: [], recalculateAll: true, processByJob: true }

  return {
    types: [RECALCULATE_ORGANIZATION_METRICS, RECALCULATE_ORGANIZATION_METRICS_SUCCESS, RECALCULATE_ORGANIZATION_METRICS_FAIL],
    promise: client => client.post('apiv2/organization/metric/recalculate', { data })
  }

}
